import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Link } from '@mui/material';
import Stack from '@mui/material/Stack';
import React from 'react';
import { Link as RouterLink } from 'react-router';

export interface Breadcrumb {
    title: string;
    path: string;
}

interface Props {
    breadcrumbs: Breadcrumb[];
    title: string;
}

export const Breadcrumbs = ({ breadcrumbs, title }: Props) => {
    return (
        <Stack
            direction="row"
            sx={{
                p: 1,
                mb: 2,
            }}
        >
            {breadcrumbs.map(({ path, title }) => (
                <React.Fragment key={title}>
                    <Link component={RouterLink} to={path} color="primary">
                        {title}
                    </Link>
                    <ChevronRightIcon />
                </React.Fragment>
            ))}
            <Box>{title}</Box>
        </Stack>
    );
};
